module.exports = __webpack_public_path__ + "static/img/article.6bb3507.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/article.svg
// module id = kvyp
// module chunks = 1 2